import './styles/zap.css';
import './player-music/player-music.css';
import { initClient } from './client.js';
import { applyTvMode } from './core/tv-mode.js';
import { applyTheme } from './core/theme.js';
import { installGlobalErrorReporter } from './core/errorReporter.js';
import { toast } from './core/toast.js';

function harnessEnabled() {
  try {
    return (
      new URLSearchParams(location.search).get('harness') === '1' ||
      localStorage.getItem('zapHarness') === '1'
    );
  } catch {
    return false;
  }
}

function boot() {
  // Resolve + apply the theme (dark default / light) BEFORE the client renders
  // so the right token set is active when stylesheets first evaluate (no flash).
  applyTheme();
  // Safety net first: catch anything no local handler catches, so silent
  // failures surface in console + a toast instead of vanishing.
  installGlobalErrorReporter({
    client: 'spa',
    notify: (m) => toast.error('Unerwarteter Fehler: ' + m),
  });
  // Detect + apply TV-mode BEFORE the client renders, so the body class is
  // in place when stylesheets are evaluated against initial DOM.
  applyTvMode();
  initClient();
  // Dev-only player repro-harness (separate chunk, only fetched when gated on).
  if (harnessEnabled()) {
    import('./player/harness.js')
      .then((m) => m.installPlayerHarness())
      .catch(() => {
        /* harness is best-effort, never blocks the app */
      });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
